import React, {Component} from "react";
import PrintLogo from "../../common/PrintLogo";
import MoheLogo from "../../common/MoheLogo";

class ResultClassInfo extends Component {
    render() {
        const {class_info} = this.props;

        return (
            <div
                className="class-info class-info--with-logos"
                style={{display: "flex", placeItems: "center", marginBottom: "50px"}}
            >
                <div
                    className="class-info-cards"
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        textTransform: "uppercase",
                    }}
                >
                    <div className="print-identity-card class-info-card class-info-card--aria">
                        <div className="class-info-card-logo">
                            <PrintLogo />
                        </div>
                        <div className="wrapper">
                            <h4>پوهنتون آریا</h4>
                            <h4>ARIA UNIVERSITY</h4>
                        </div>
                    </div>

                    <div className="print-identity-card class-info-card">
                        <div className="class-info-card-logo class-info-card-logo--spacer" aria-hidden="true" />
                        <div className="wrapper">
                            <h4>{class_info?.faculty}</h4>
                            <h4>Faculty Of {class_info?.faculty_en}</h4>
                        </div>
                    </div>

                    {class_info?.department ? (
                        <div className="print-identity-card class-info-card">
                            <div className="class-info-card-logo class-info-card-logo--spacer" aria-hidden="true" />
                            <div className="wrapper">
                                <h4>({class_info?.department}) دپارتمنت</h4>
                                <h4>DEPARTMENT ({class_info?.department_en})</h4>
                            </div>
                        </div>
                    ) : null}

                    <div className="print-identity-card class-info-card class-info-card--results">
                        <div className="class-info-card-logo">
                            <MoheLogo />
                        </div>
                        <div className="wrapper">
                            <h4>جدول نتایج {class_info?.class_desc}</h4>
                            <h4>
                                {class_info?.faculty} ({class_info?.entry_year}) {class_info?.time}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ResultClassInfo;
